import { render } from "./MainRankingFinal.vue?vue&type=template&id=6f65e169&scoped=true"
import script from "./MainRankingFinal.vue?vue&type=script&lang=js"
export * from "./MainRankingFinal.vue?vue&type=script&lang=js"

import "./MainRankingFinal.vue?vue&type=style&index=0&id=6f65e169&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f65e169"]])

export default __exports__